module.exports = __webpack_public_path__ + "static/media/connect.c9149cb8.svg";